<template>
  <div :class="['newsletterText', `newsletterText--${layout}`]">
    <h3 class="newsletterText__bigTitle">{{ bigTitle }}</h3>
    <p class="newsletterText__desc">{{ desc }}</p>
  </div>
</template>
<script>
export default {
  name: 'NewsletterText',
  props: {
    bigTitle: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
    layout: {
      type: String,
      default: 'inline',
    },
  },
};
</script>
<style lang="scss">
.newsletterText {
  $root: &;

  @include rwd('tablet') {
    text-align: center;
  }

  &__bigTitle {
    font-size: 3.6rem;
    line-height: 4.5rem;
    font-weight: 600;
    margin-bottom: 0.8rem;

    @include rwd('large-tablet') {
      font-size: 3rem;
      line-height: 3.8rem;
      margin-bottom: 0.2rem;
    }

    @include rwd('phone') {
      font-size: 2.6rem;
      line-height: 3rem;
    }
  }

  &__desc {
    font-size: 1.8rem;
    line-height: 2.4rem;
    color: $cAddDark02;

    @include rwd('large-tablet') {
      font-size: 1.6rem;
      line-height: 2.2rem;
      color: $cMainNeutral;
    }
  }

  &--grid {
    #{$root}__bigTitle {
      font-size: 2.8rem;
      line-height: 3.6rem;
    }

    #{$root}__desc {
      font-size: 1.6rem;
      line-height: 2.2rem;
    }
  }
}
</style>
